import { useEffect, useEffectEvent } from 'react';
import { matchPath, useLocation } from 'react-router';

import { catchAll } from '@sorare/routing';

import { ANY_SPORT_SERIES } from '#src/constants/__generated__/routes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { useLockProMode } from '#src/hooks/useLockProMode.ts';
import { useUnlockProMode } from '#src/hooks/useUnlockProMode.ts';
import {
  SPORT_PATH_MAP,
  isSharedProSetPath,
  matchAnySportPath,
} from '#src/lib/routing/generateSportPath.ts';

export const useAutoSyncProMode = () => {
  const { currentUser } = useCurrentUserContext();
  const { sport } = useSportContext();
  const { pathname } = useLocation();
  const { lockProMode } = useLockProMode();
  const { unlockProMode } = useUnlockProMode();

  const syncProMode = useEffectEvent(() => {
    if (!currentUser) return;

    const proUnlocked = currentUser.anyUserSportProfile?.proUnlocked;

    if (isSharedProSetPath(pathname)) {
      return;
    }

    const isSeriesPage = !!matchAnySportPath(
      catchAll(ANY_SPORT_SERIES),
      pathname
    );
    const isSportPage = Object.values(SPORT_PATH_MAP).some(path =>
      matchPath(catchAll(path), pathname)
    );

    if (isSeriesPage && proUnlocked) {
      lockProMode({
        variables: {
          sport,
          input: { sport, interactionContext: 'auto-route' },
        },
      });
    } else if (isSportPage && !isSeriesPage && !proUnlocked) {
      unlockProMode({
        variables: {
          sport,
          input: { sport, interactionContext: 'auto-route' },
        },
      });
    }
  });

  useEffect(() => {
    syncProMode();
  }, [pathname]);
};
